import { type ColumnDef } from '@tanstack/react-table';

interface GroupColumnOptions<T> {
  accessorKey: keyof T;
  header: string;
}

export const GroupColumn = <T extends object>({ accessorKey, header }: GroupColumnOptions<T>): ColumnDef<T> => ({
  accessorKey: String(accessorKey),
  header: () => header,
  enableHiding: false,
  enableGrouping: true, // since this is a grouping column this is always true
  // no need for a cell renderer
});
